import { PriceRow, RemoveButton, TextRow, VoidedButton } from 'components';
import React from 'react';
import { Images, PermissionsList, RolePermission } from 'utils';

export const paymentMethodENums = {
  CHECK: 'CHECK',
  ACH: 'ACH',
  COD: 'COD',
  LOCKBOX: 'LOCKBOX',
  WIRE: 'WIRE',
  ZELLE: 'ZELLE',
  PAYPAL: 'PAYPAL',
  CREDIT_CARD: 'CREDIT_CARD',
  COLLECTIONS: 'COLLECTIONS',
};
export const paymentMethods = [
  { name: 'Credit Card', id: paymentMethodENums.CREDIT_CARD },
  { name: 'Collections', id: paymentMethodENums.COLLECTIONS },
  { name: 'Check', id: paymentMethodENums.CHECK },
  { name: 'Ach', id: paymentMethodENums.ACH },
  { name: 'Cod', id: paymentMethodENums.COD },
  { name: 'Lockbox', id: paymentMethodENums.LOCKBOX },
  { name: 'Wire', id: paymentMethodENums.WIRE },
  { name: 'Zelle', id: paymentMethodENums.ZELLE },
  { name: 'Paypal', id: paymentMethodENums.PAYPAL },
];

export const checkStatus = (info) => {
  if (info) {
    return info.status !== 'VOIDED';
  }
};

export const aboutFactoring = (info) => {
  if (info) {
    if (info.factoringName) {
      return true;
    } else {
      return !!(info?.customers && info.customers.length < 1);
    }
  }
};

export const sourceEnum = {
  BOA: 'BOA',
  MVB: 'MVB',
  FFB: 'FFB',
  OTHER: 'OTHER',
};
export const sourceList = [
  { name: 'BOA', id: sourceEnum.BOA },
  { name: 'MVB', id: sourceEnum.MVB },
  { name: 'FFB', id: sourceEnum.FFB },
  { name: 'Other', id: sourceEnum.OTHER },
];


export const pmtLoadHead = [
  { name: '', title: 'Display ID', custom: false },
  { name: '', title: 'Amount', custom: false },
  // { name: '', title: 'Paid Amount', custom: false },
  { name: '', title: 'Description', custom: false },
];

export const pmtLoadBody = [
  { rowText: (item) => <div>{item?.displayId}</div> },
  { rowText: (item) => <PriceRow info={item?.amount} /> },
  // { rowText: (item) => <PriceRow info={item?.used} /> },
  {
    button: (fn, item) => <div className="flex-align-center" style={{ gap: 6 }}>
      <TextRow name={item?.description} />

      {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.VOID_CUSTOMER_PAYMENT?.code]) &&
        <div onClick={(e) => e.stopPropagation()}>
          {!checkStatus(item) ?
            <VoidedButton />
            :
            <RemoveButton
              text={'Void'}
              handleClick={() => fn('void')}
            />
          }
        </div>
      }
      <button
        className="reset-btn"
        onClick={(e) => {
          e.stopPropagation();
          fn('edit');
        }}
      >
        <img src={Images.edit} alt="edit" />
      </button>
    </div>,
  },
];

export const CUSTOMER_PMT_LOADS = 'GET_CUSTOMER_PAYMENT_LOAD';